import { Edit, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { OrgManagerFormFields } from './OrgManagerForm';

export const OrgManagerEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm toolbar={<MyToolbar resource="orgManagers" />}>
      <MyFormContainer>
        <OrgManagerFormFields isCreate={false} />
      </MyFormContainer>
    </SimpleForm>
  </Edit>
);

export default OrgManagerEdit;
